import { get, post } from "./index";

export const searchAirports = (params) => {
  const request = {
    subUrl: `/website/getAllAirports`,
    params,
  };
  return get(request);
};

export const createInquiry = (data) => {
  const request = {
    subUrl: `/website/inquiry`,
    data,
  };
  return post(request);
};
export const createEVisaInquiry = (data) => {
  const request = {
    subUrl: `/website/inquiry/evisa`,
    data,
    isFormData:true
  };
  return post(request);
};

export const createHajjInquiry = (data) => {
  const request = {
    subUrl: `/website/inquiry/evisa`,
    data,
  };
  return post(request);
};

